const $ = jQuery.noConflict();
const controller = {
    init() {
        $('.featured-listings__cards').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite     : true,
            nextArrow    : '.featured-listings__next-btn',
            prevArrow    : '.featured-listings__prev-btn',
            dots         : false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        variableWidth: false,
                    }
                },
            ]
        })
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
